import { h } from 'preact'
import EmptyPage from '../empty-page/EmptyPage'
import globals from '../../utils/globals'
import Overview from '../overview'
import UserCell from '../overview/cells/UserCell'
import DateCell from '../overview/cells/DateCell'
import TitleCell from '../overview/cells/TitleCell'
import StatusCell from '../overview/cells/StatusCell'
import ActionByUserCell from '../overview/cells/ActionByUserCell'
import { ParentCategory } from '../category-selector/CategorySelector'
import { ModerationLabel } from '../overview/filters/types'
import { moderationLabel, publishedIn, author } from '../overview/filters/filters'

type Props = {
  categories: ParentCategory[],
  moderationLabels: ModerationLabel[],
}

const ArticleOverview = ({ categories, moderationLabels } : Props) => {
  function getFilters () {
    return [
      publishedIn(categories),
      moderationLabel(moderationLabels),
      author()
    ]
  }

  function getColumns () {
    return [
      { header: 'Title', accessor: 'title', cell: TitleCell(), size: 'xl', isFixed: true },
      { header: 'Status', accessor: 'status', cell: StatusCell(), size: 'xs' },
      { header: 'Category', accessor: 'categoryName', size: 'l' },
      { header: 'Publish date', accessor: 'publishedAt', cell: DateCell('publishedAt'), sorting: 'publishedAt' },
      { header: 'Author', accessor: 'author', cell: UserCell('author') },
      { header: 'Last edited', accessor: 'last_edited_date', cell: ActionByUserCell('lastEdit'), sorting: 'lastEditedAt', size: 'l' }
    ]
  }

  return <Overview
    type='article'
    headerTitle='Articles'
    withPagination={{
      page: 1,
      pageSize: 25
    }}
    withSorting={{
      lastEditedAt: 'desc'
    }}
    withFilters={getFilters()}
    withSearch
    searchPlaceholder='Search in title and content'
    withColumns
    rowId='id'
    model={getColumns()}
    endpoint='/article/overview/topics'
    dataKey='topics'
    EmptyStateComponent={<EmptyPage
      img_src={`${globals('defaultCdn')}/images/empty_page.png`}
      header='There are no articles yet'
      text={'Seems like no one on your team has created an article. \n Start now by creating a new article.'}
      button={{ link: '/content/new/article', text: 'New article' }}
    />}
  />
}

export default ArticleOverview
